import { render, staticRenderFns } from "./partnerInfo.vue?vue&type=template&id=0c9b24d9&scoped=true&"
import script from "./partnerInfo.vue?vue&type=script&lang=js&"
export * from "./partnerInfo.vue?vue&type=script&lang=js&"
import style0 from "./partnerInfo.vue?vue&type=style&index=0&id=0c9b24d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9b24d9",
  null
  
)

export default component.exports